module.exports = __webpack_public_path__ + "static/media/thrive.5ffd17be.png";